import BaseBox from '@material-ui/core/Box';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import DatePicker, { DatePickerProps } from '@material-ui/lab/DatePicker';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import { useContextCheckboxWithOptionalContent } from 'components/CheckboxWithOptionalContent';
import { useContextRadioButtonWithOptionalContent } from 'components/RadioButtonWithOptionalContent';
import { TextFieldStyle } from 'components/TextInput';
import { de } from 'date-fns/locale';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ReactComponent as DateIcon } from './assets/DateIcon.svg';

const Box = styled(BaseBox)`
  .MuiInputAdornment-root {
    padding-right: 4px;
  }
  .MuiIconButton-root {
    width: 39px;
  }
  .Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: #f44336 !important;
  }
  label.MuiFormLabel-filled + .MuiInputBase-root legend {
    padding: 0 2px;
  }
`;
const AdaptDatePicker = styled(DatePicker)`
  .MuiMonthPicker-root button {
    background: none;
    border: none;
  }
`;

type Props = {
  form?: any;
  field?: any;
  editable?: boolean;
  disabled?: boolean;
  wrapper: Record<string, unknown>;
  views?: string[];
  filter?: boolean;
};

const KeyboardTimePickerInput: React.VFC<Props & DatePickerProps> = ({
  form: { setFieldValue },
  field: { value, name, onChange, ...fields },
  editable,
  disabled,
  wrapper = {},
  views = ['day'],
  filter = false,
  ...rest
}) => {
  const { checked } = useContextCheckboxWithOptionalContent();
  const { valueChecked } = useContextRadioButtonWithOptionalContent();

  useEffect(() => {
    if (checked !== undefined && !checked && setFieldValue && fields.value) {
      setFieldValue(name, undefined);
    }

    if (valueChecked !== undefined && !valueChecked && setFieldValue && fields.value) {
      setFieldValue(name, undefined);
    }
  }, [checked, valueChecked, name, setFieldValue, fields.value]);

  const handleCheckShrinkShow = () => {
    if (!editable) {
      return true;
    }

    return !!value;
  };

  const formatDate = (name: string, value: Date) => {
    switch (name) {
      case 'startDate':
        return value ? new Date(value.setHours(0, 0, 0)) : undefined;
      case 'endDate':
        return value ? new Date(value.setHours(23, 59, 59)) : undefined;
      default:
        return value;
    }
  };

  const { inputFormat } = rest;

  useEffect(() => {
    const exceptions = ['dateOfBirth', 'moveOutDate', 'moveInDate'];
    if (
      value &&
      exceptions.find((element) => name.includes(element)) &&
      typeof value === 'object'
    ) {
      value.setHours(22, 0, 0);
    }
  }, [name, value]);

  return (
    <Box
      sx={{
        py: 1.25,
        ...wrapper,
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={de}>
        <AdaptDatePicker
          views={views}
          openTo="day"
          openPickerIcon={<DateIcon />}
          disabled={!editable}
          {...fields}
          {...rest}
          mask={inputFormat === 'dd.MM.yyyy' ? '__.__.____' : '__.__.____ __:__'}
          value={!value ? null : filter ? formatDate(name, value) : value}
          onChange={(value: Date) => {
            setFieldValue(name, filter ? formatDate(name, value) : value);
          }}
          renderInput={({ inputProps, ...params }) => (
            <TextFieldStyle
              {...params}
              margin="normal"
              name={name}
              helperText={null}
              InputLabelProps={{
                shrink: handleCheckShrinkShow(),
              }}
              inputProps={{
                ...inputProps,
                placeholder: editable ? inputProps?.placeholder : '',
              }}
            />
          )}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default KeyboardTimePickerInput;
